import { StoreDispatch } from "../config/configureStore";
import { useDispatch } from "react-redux";

// TODO: this is not correctly resolving redux-thunk
export const useThunkDispatch = () => useDispatch<StoreDispatch>();
